import { AuthRoutesEnum } from '@/router/AuthRoutes';
import { createAuth0 } from '@auth0/auth0-vue';

const domain = import.meta.env.VITE_EIKON_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_EIKON_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_EIKON_AUTH0_AUDIENCE;
const redirectUri = `${import.meta.env.VITE_EIKON_APP_URL}${AuthRoutesEnum.process}`;
export const scope = 'openid email permissions';
const responseType = 'token id_token';

const auth = createAuth0(
  {
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: redirectUri,
      audience,
      scope,
      responseType,
    },
  },
  {
    errorPath: '/error',
  }
);

export { auth };
